import { axios } from '../index'

const deleteFolderAccess = (folderId: string, accessProfileId: number) => {
  return axios.delete(
    `/v1/group-folders/${folderId}/profile/${accessProfileId}`
  )
}

export default deleteFolderAccess
